<div class="container-fluid">
  <div class="col-12">
    <p [innerHTML]="componentData.content"></p>
  </div>
</div>